import { ROUTES } from "const";
import { courseService } from "libs/api";

export class ABILITAZIONE60CFUMANIFESTO_UNICAMILLUS {

  static async getDashboardCards(courseCode, registrationCode, aa) {

    let cards = this.getFixedCards(courseCode, aa);

    const result = await courseService.perfezionamentoActiveLink(
      registrationCode
    );

    if (result.data.payload) {
      const { payload } = result.data;
      try {

        if (payload.activeSurvey && payload.activeSurvey.length > 0) {
          cards.push({
            title: payload.activeSurvey,
            link: ROUTES.COURSE_SURVEY_MAIN + "/" + payload.activeSurvey,
            img: "/img/icon/call.png",
            className: "image-box",
          });
        }

        if (result.data.payload.examReservationEnabled === "1") {
          cards.push({
            title: 'Prenotazione prova finale',
            link: ROUTES.CFUALL_EXAM_RESERVATION,
            img: '/img/icon/7.webp',
            className: 'image-box'
          });
        }

        if (result.data.payload.enableUDA === "1") {

          cards.push({
            title: "Prova scritta",
            link: ROUTES.COURSE_CFU60ALL1_UDA_EXAMWRITTEN,
            img: "/img/icon/examdone.png",
            className: "image-box",
          });
        }

        if (result.data.payload.enableExamSubject === "1") {
          cards.push({
            title: "Argomento Lezione Simulata",
            link: ROUTES.COURSE_RC30_EXAM_SUBJECT,
            img: "/img/icon/7.png",
            className: "image-box",
          });
        }

        if (payload.titleRequestEnabled === "1") {
          cards.push({
            title: 'Certificato Finale',
            link: ROUTES.MU_UM_TITLE_DONWLOAD,
            img: '/img/icon/graduate.png',
            className: 'image-box'
          });
        }

        if (payload.certRequestEnabled === "1") {
          cards.push({
            title: "Consultazione Esito Finale",
            link: ROUTES.COURSE_RC30_CERT_REQUEST,
            img: "/img/icon/1.png",
            className: "image-box",
          });
        }
      } catch (error) { }
    }


    return cards;
  }

  static getFixedCards(courseCode, aa) {

    return [
      {
        title: "Autocertificazione d'iscrizione",
        link: ROUTES.USER_SELF_DECLARATION,
        img: "/img/icon/badge.png",
        className: "image-box",
      },
      {
        title: "Messaggi",
        link: ROUTES.COURSE_TICKETS,
        img: "/img/icon/message.png",
        className: "image-box",
      },
      {
        title: "Situazione pagamenti",
        link: ROUTES.MU_COURSE_PAYMENTS,
        img: "/img/icon/payment.png",
        className: "image-box",
      },
      {
        title: "Attività Formative",
        link: ROUTES.COURSE_LESSONSECTION_SCHEDULE,
        img: "/img/icon/3.png",
        className: "image-box",
      },
      {
        title: "Lezioni telematiche in modalità sincrona",
        link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL,
        img: "/img/icon/presentation.png",
        className: "image-box",
      },
      {
        title: "Lezioni in presenza",
        link: ROUTES.COURSE_LESSONONSITE_SCHEDULE,
        img: "/img/icon/3.png",
        className: "image-box",
      },
      {
        title: "Tirocinio Indiretto",
        link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE,
        img: "/img/icon/8.webp",
        className: "image-box",
      },
      {
        title: "Tirocinio diretto",
        link: ROUTES.COURSE_TIROCINIODIRETTO_DETAIL,
        img: "/img/icon/8.webp",
        className: "image-box",
      },
      {
        title: "Badge Accesso Aula",
        link: ROUTES.MY_BADGE,
        img: "/img/icon/1.png",
        className: "image-box",
      }
    ];
  }

  static getDashboardNotices() {

    return [
      {
        title: `Materiale didattico Tirocinio Indiretto `,
        content: `<p>Lezione - Le competenze e il portfolio 
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/LezioneLecompetenzeeilportfolioUnicamillus.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>
            <p>Lezione - Esame finale - Prova scritta 
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/LezioneEsamefinaleProvascrittaUnicamillus.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>
            <p>   Lezione - Esame finale - Lezione simulata
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/LezioneEsamefinaleLezionesimulataUnicamillus.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
      },
      {
        title: `Criteri di valutazione della prova finale`,
        content: `<ul>
            <li>Prova scritta <a href="https://www.formazionedocenti.it/files/corsi/UM306036/CriteridivalutazioneProvascritta60cfu.pdf" target="_blank"> Prova scritta  Clicca qui per scaricare l'informativa</a></li>
            <li>Lezione simulata <a href="https://www.formazionedocenti.it/files/corsi/UM306036/CriteridivalutazioneLezionesimulata60cfu.pdf" target="_blank">Lezione simulata  Clicca qui per scaricare l'informativa</a></li>
            </ul>`,
      },
      {
        content: `<p>Modalità di svolgimento della prova finale 
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/Modalità_svolgimento_prova_finale60cfu_unicamillus.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
      },
      {
        content: `<p>Calendario Esami Percorsi Abilitanti a.a. 25/26 (aggiornato al 16/05/2026)
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/calendario_esami.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
      },
      {
        content: `<p>Linee guida alla redazione della Relazione Tirocinio Diretto. 
            <a href="https://www.formazionedocenti.it/files/corsi/RC3060/Linee_guida_alla_redazione_della_Relazione_Tirocinio_Diretto.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
      },
      {
        title: ` Calcolo percentuale presenza`,
        content: `Per l’accesso alla prova finale, le cui modalità di svolgimento sono definite dall’art. 9 del DPCM del 4 agosto 2023, è necessaria una percentuale minima di frequenza alle attività formative pari al 70% per ogni attività formativa.
Le attività formative sono disponibili nell’apposita sezione “Attività Formative” con la relativa indicazione della “Percentuale di frequenza” che, per ogni specifica sezione, per l'accesso alla prova finale, dovrà raggiungere necessariamente una percentuale minima di presenza pari al 70%.`
      },
      {
        content: `Si informano gli studenti che le percentuali delle presenze verranno aggiornate entro 24 ore dall’avvenuto svolgimento della lezione.`
      },
      {
        content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/UM306036/linee-guida-lezioni-unicamillus.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
      },
      {
        title: `Sedi lezioni in presenza`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/UM306036/Sedi_Unicamillus_lezioni_in_presenza.pdf" target="_blank">Clicca qui per scaricare il file</a>`
      },
      {
        title: `Sedi e Indirizzi lezioni in presenza`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/UM306036/Sedi_e_indirizzi_Unicamillus_lezioni_in_presenza_60CFU.pdf" target="_blank">Clicca qui per scaricare il file</a>`
      },
    ];
  }
}
